export default __webpack_public_path__ + "static/media/Samridhi_Outreach And Event Management Team.f8166b8f.jpg";